export default {
  ERROR: 'error',
  API_ERROR: 'api_error',
  EMPTY: 'empty'
};
